exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mapping-item[data-v-02cbeb1d] {\n  margin-bottom: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.field-label[data-v-02cbeb1d] {\n  width: 100px;\n  text-align: right;\n}\n.el-form-item__error[data-v-02cbeb1d] {\n  /* 调整校验提示位置，避免遮挡 */\n  padding-left: 110px;\n}\n", ""]);

// exports
